// import React, { useState, useEffect } from 'react';
// import PrimaryNavigation from '../../components/ui/PrimaryNavigation';
// import NavigationBreadcrumb from '../../components/ui/NavigationBreadcrumb';
// import Button from '../../components/ui/Button';
// import MetricsCard from './components/MetricsCard';
// import ArticlePerformanceBubble from './components/ArticlePerformanceBubble';

// import TrendingTopics from './components/TrendingTopics';
// import MissingContent from './components/MissingContent';
// import RecentUpdates from './components/RecentUpdates';
// import ContentTable from './components/ContentTable';
// import SearchAnalytics from './components/SearchAnalytics';
// import UsageHeatMap from './components/UsageHeatMap';
// import KnowledgeBaseTable from './components/KnowledgeBaseTable';
// import CreateKnowledgeBaseModal from './components/CreateKnowledgeBaseModal';
// import EditKnowledgeBasePane from './components/EditKnowledgeBasePane';
// import HistoryPane from './components/HistoryPane';

// const KnowledgeBaseAnalytics = () => {
//   const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
//   const [isEditPaneOpen, setIsEditPaneOpen] = useState(false);
//   const [isHistoryPaneOpen, setIsHistoryPaneOpen] = useState(false);
//   const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState(null);

//   const availableAgents = [
//   { id: 'agent-1', name: 'Sales Agent' },
//   { id: 'agent-2', name: 'Support Agent' },
//   { id: 'agent-3', name: 'Technical Agent' },
//   { id: 'agent-4', name: 'Billing Agent' },
//   { id: 'agent-5', name: 'Customer Success Agent' },
//   { id: 'agent-6', name: 'Onboarding Agent' }];


//   const knowledgeBases = [
//   {
//     id: 'kb-1',
//     name: 'Product Documentation',
//     type: 'Link',
//     link: 'https://docs.example.com/product',
//     lastUpdated: 'Jan 2, 2026',
//     createdBy: 'John Smith',
//     usedByAgents: ['Sales Agent', 'Support Agent', 'Technical Agent']
//   },
//   {
//     id: 'kb-2',
//     name: 'Billing Policy Guide',
//     type: 'Doc',
//     link: 'billing-policy-v2.pdf',
//     lastUpdated: 'Dec 28, 2025',
//     createdBy: 'Sarah Johnson',
//     usedByAgents: ['Billing Agent', 'Support Agent']
//   },
//   {
//     id: 'kb-3',
//     name: 'API Integration Guide',
//     type: 'Link',
//     link: 'https://api.example.com/docs',
//     lastUpdated: 'Dec 20, 2025',
//     createdBy: 'Mike Chen',
//     usedByAgents: ['Technical Agent']
//   },
//   {
//     id: 'kb-4',
//     name: 'Customer Onboarding Checklist',
//     type: 'Doc',
//     link: 'onboarding-checklist.docx',
//     lastUpdated: 'Dec 15, 2025',
//     createdBy: 'Emily Davis',
//     usedByAgents: ['Onboarding Agent', 'Customer Success Agent', 'Sales Agent']
//   },
//   {
//     id: 'kb-5',
//     name: 'Troubleshooting FAQ',
//     type: 'Link',
//     link: 'https://support.example.com/faq',
//     lastUpdated: 'Jan 1, 2026',
//     createdBy: 'David Wilson',
//     usedByAgents: ['Support Agent', 'Technical Agent']
//   }];


//   const historyDataMap = {
//     'kb-1': [
//     {
//       timestamp: '2026-01-02T10:30:00',
//       user: 'John Smith',
//       change: 'Link Changed: Updated to new documentation URL'
//     },
//     {
//       timestamp: '2025-12-15T14:20:00',
//       user: 'Sarah Johnson',
//       change: 'Agent added: Technical Agent'
//     },
//     {
//       timestamp: '2025-12-01T09:15:00',
//       user: 'John Smith',
//       change: 'Name Changed: From "Product Docs" to "Product Documentation"'
//     }],

//     'kb-2': [
//     {
//       timestamp: '2025-12-28T16:45:00',
//       user: 'Sarah Johnson',
//       change: 'New Doc Uploaded: billing-policy-v2.pdf'
//     },
//     {
//       timestamp: '2025-12-20T11:30:00',
//       user: 'Mike Chen',
//       change: 'Agent removed: Sales Agent'
//     }],

//     'kb-3': [
//     {
//       timestamp: '2025-12-20T13:00:00',
//       user: 'Mike Chen',
//       change: 'Link Changed: Updated API endpoint documentation'
//     }],

//     'kb-4': [
//     {
//       timestamp: '2025-12-15T10:00:00',
//       user: 'Emily Davis',
//       change: 'Agent added: Sales Agent'
//     },
//     {
//       timestamp: '2025-12-10T15:30:00',
//       user: 'Emily Davis',
//       change: 'New Doc Uploaded: onboarding-checklist.docx'
//     }],

//     'kb-5': [
//     {
//       timestamp: '2026-01-01T08:00:00',
//       user: 'David Wilson',
//       change: 'Link Changed: Updated FAQ page URL'
//     },
//     {
//       timestamp: '2025-12-25T12:00:00',
//       user: 'David Wilson',
//       change: 'Agent added: Technical Agent'
//     }]

//   };

//   const handleEdit = (kb) => {
//     setSelectedKnowledgeBase(kb);
//     setIsEditPaneOpen(true);
//   };

//   const handleDelete = (kb) => {
//     console.log('Delete knowledge base:', kb);
//   };

//   const handleHistory = (kb) => {
//     setSelectedKnowledgeBase(kb);
//     setIsHistoryPaneOpen(true);
//   };

//   const handleCloseEditPane = () => {
//     setIsEditPaneOpen(false);
//     setSelectedKnowledgeBase(null);
//   };

//   const handleCloseHistoryPane = () => {
//     setIsHistoryPaneOpen(false);
//     setSelectedKnowledgeBase(null);
//   };

//   const topMetrics = [
//   {
//     title: "Total Articles",
//     value: "1,247",
//     change: "+23 this month",
//     changeType: "positive",
//     icon: "FileText",
//     iconColor: "bg-gradient-to-br from-primary to-secondary",
//     description: "Active knowledge base content"
//   },
//   {
//     title: "Utilization Rate",
//     value: "78.4%",
//     change: "+5.2% vs last month",
//     changeType: "positive",
//     icon: "TrendingUp",
//     iconColor: "bg-gradient-to-br from-success to-secondary",
//     description: "Articles accessed in last 30 days"
//   },
//   {
//     title: "Avg. Effectiveness",
//     value: "82.1%",
//     change: "+3.8% improvement",
//     changeType: "positive",
//     icon: "Target",
//     iconColor: "bg-gradient-to-br from-accent to-warning",
//     description: "Resolution success rate"
//   },
//   {
//     title: "Content Freshness",
//     value: "91.2%",
//     change: "-2.1% needs update",
//     changeType: "negative",
//     icon: "RefreshCw",
//     iconColor: "bg-gradient-to-br from-secondary to-primary",
//     description: "Updated within 90 days"
//   }];


//   const bubbleChartData = [
//   { id: 1, title: "How to reset password", views: 2450, successRate: 92, rating: 4.8, category: "account" },
//   { id: 2, title: "Billing cycle explained", views: 1890, successRate: 88, rating: 4.6, category: "billing" },
//   { id: 3, title: "API integration guide", views: 1650, successRate: 75, rating: 4.2, category: "technical" },
//   { id: 4, title: "Setting up two-factor auth", views: 1420, successRate: 85, rating: 4.5, category: "account" },
//   { id: 5, title: "Understanding pricing tiers", views: 1280, successRate: 90, rating: 4.7, category: "billing" },
//   { id: 6, title: "Troubleshooting connection issues", views: 1150, successRate: 68, rating: 3.9, category: "technical" },
//   { id: 7, title: "Managing team members", views: 980, successRate: 82, rating: 4.4, category: "account" },
//   { id: 8, title: "Payment method updates", views: 890, successRate: 86, rating: 4.5, category: "billing" },
//   { id: 9, title: "Advanced feature configuration", views: 750, successRate: 72, rating: 4.1, category: "product" },
//   { id: 10, title: "Data export procedures", views: 680, successRate: 78, rating: 4.3, category: "product" },
//   { id: 11, title: "Security best practices", views: 620, successRate: 88, rating: 4.6, category: "technical" },
//   { id: 12, title: "Mobile app setup", views: 580, successRate: 80, rating: 4.4, category: "product" },
//   { id: 13, title: "Subscription cancellation", views: 520, successRate: 92, rating: 4.8, category: "billing" },
//   { id: 14, title: "Webhook configuration", views: 450, successRate: 65, rating: 3.8, category: "technical" },
//   { id: 15, title: "Custom domain setup", views: 380, successRate: 70, rating: 4.0, category: "technical" }];


//   const categoryData = [
//   {
//     id: 1,
//     name: "Billing & Payments",
//     icon: "CreditCard",
//     articleCount: 156,
//     totalViews: 45280,
//     performance: 87,
//     avgRating: 4.6,
//     topArticles: [
//     { id: 1, title: "Understanding your invoice", views: 3420, successRate: 91, rating: 4.8 },
//     { id: 2, title: "Payment method updates", views: 2890, successRate: 88, rating: 4.7 },
//     { id: 3, title: "Refund policy explained", views: 2650, successRate: 85, rating: 4.5 }]

//   },
//   {
//     id: 2,
//     name: "Technical Support",
//     icon: "Wrench",
//     articleCount: 342,
//     totalViews: 78920,
//     performance: 72,
//     avgRating: 4.2,
//     topArticles: [
//     { id: 1, title: "API troubleshooting guide", views: 4120, successRate: 76, rating: 4.3 },
//     { id: 2, title: "Connection error solutions", views: 3890, successRate: 70, rating: 4.1 },
//     { id: 3, title: "Performance optimization tips", views: 3450, successRate: 68, rating: 4.0 }]

//   },
//   {
//     id: 3,
//     name: "Account Management",
//     icon: "User",
//     articleCount: 198,
//     totalViews: 52340,
//     performance: 85,
//     avgRating: 4.5,
//     topArticles: [
//     { id: 1, title: "Password reset procedures", views: 5420, successRate: 93, rating: 4.9 },
//     { id: 2, title: "Profile settings guide", views: 4280, successRate: 87, rating: 4.6 },
//     { id: 3, title: "Team member management", views: 3920, successRate: 82, rating: 4.4 }]

//   },
//   {
//     id: 4,
//     name: "Product Features",
//     icon: "Zap",
//     articleCount: 289,
//     totalViews: 61450,
//     performance: 79,
//     avgRating: 4.3,
//     topArticles: [
//     { id: 1, title: "Getting started guide", views: 6120, successRate: 88, rating: 4.7 },
//     { id: 2, title: "Advanced features overview", views: 4890, successRate: 75, rating: 4.2 },
//     { id: 3, title: "Integration capabilities", views: 4320, successRate: 72, rating: 4.1 }]

//   }];


//   const trendingTopics = [
//   {
//     id: 1,
//     title: "AI agent configuration best practices",
//     searches: 1847,
//     change: "+127% vs last week",
//     trend: "up",
//     relatedArticles: ["Setup Guide", "Advanced Config"]
//   },
//   {
//     id: 2,
//     title: "Multi-channel integration setup",
//     searches: 1523,
//     change: "+89% vs last week",
//     trend: "up",
//     relatedArticles: ["WhatsApp Setup", "Email Config"]
//   },
//   {
//     id: 3,
//     title: "Call recording compliance requirements",
//     searches: 1289,
//     change: "+64% vs last week",
//     trend: "up",
//     relatedArticles: ["Legal Guide", "Storage Options"]
//   },
//   {
//     id: 4,
//     title: "Performance optimization techniques",
//     searches: 1156,
//     change: "+52% vs last week",
//     trend: "up",
//     relatedArticles: ["Speed Tips", "Best Practices"]
//   },
//   {
//     id: 5,
//     title: "Custom workflow automation",
//     searches: 987,
//     change: "-12% vs last week",
//     trend: "down",
//     relatedArticles: ["Workflow Builder", "Automation Rules"]
//   }];


//   const missingContentGaps = [
//   {
//     id: 1,
//     topic: "Advanced webhook retry logic configuration",
//     description: "Multiple escalations indicate customers need detailed guidance on configuring webhook retry mechanisms and failure handling strategies.",
//     escalationCount: 47,
//     failedSearches: 156,
//     priority: "high"
//   },
//   {
//     id: 2,
//     topic: "GDPR compliance for call recordings",
//     description: "Increasing queries about data retention policies, customer consent management, and right-to-deletion procedures for recorded conversations.",
//     escalationCount: 34,
//     failedSearches: 128,
//     priority: "high"
//   },
//   {
//     id: 3,
//     topic: "Custom AI training with industry-specific terminology",
//     description: "Enterprise customers requesting documentation on training AI agents with specialized vocabulary and domain-specific language patterns.",
//     escalationCount: 28,
//     failedSearches: 94,
//     priority: "medium"
//   },
//   {
//     id: 4,
//     topic: "Multi-language support implementation",
//     description: "Growing demand for guidance on setting up and managing AI agents that can handle conversations in multiple languages simultaneously.",
//     escalationCount: 22,
//     failedSearches: 76,
//     priority: "medium"
//   }];


//   const recentUpdates = [
//   {
//     id: 1,
//     title: "Updated: API rate limiting best practices",
//     date: "2 hours ago",
//     type: "updated",
//     impact: "positive",
//     impactValue: "+18% success rate",
//     viewsChange: "+245 views",
//     successRate: 89
//   },
//   {
//     id: 2,
//     title: "New: WhatsApp Business API integration guide",
//     date: "5 hours ago",
//     type: "new",
//     impact: "positive",
//     impactValue: "+32 escalations resolved",
//     viewsChange: "412 views",
//     successRate: 85
//   },
//   {
//     id: 3,
//     title: "Updated: Billing cycle FAQ with new examples",
//     date: "1 day ago",
//     type: "updated",
//     impact: "positive",
//     impactValue: "+12% success rate",
//     viewsChange: "+189 views",
//     successRate: 91
//   },
//   {
//     id: 4,
//     title: "Archived: Legacy API v1 documentation",
//     date: "2 days ago",
//     type: "archived",
//     impact: "neutral",
//     impactValue: "No impact",
//     viewsChange: "-156 views",
//     successRate: 0
//   }];


//   const articleTableData = [
//   {
//     id: 1,
//     title: "How to reset your account password",
//     category: "Account Management",
//     views: 5420,
//     successRate: 93,
//     rating: 4.9,
//     effectiveness: 91,
//     lastUpdated: "2 days ago"
//   },
//   {
//     id: 2,
//     title: "Understanding your monthly invoice",
//     category: "Billing & Payments",
//     views: 4890,
//     successRate: 88,
//     rating: 4.7,
//     effectiveness: 86,
//     lastUpdated: "1 week ago"
//   },
//   {
//     id: 3,
//     title: "API integration quickstart guide",
//     category: "Technical Support",
//     views: 4320,
//     successRate: 76,
//     rating: 4.3,
//     effectiveness: 74,
//     lastUpdated: "3 days ago"
//   },
//   {
//     id: 4,
//     title: "Setting up two-factor authentication",
//     category: "Account Management",
//     views: 3980,
//     successRate: 87,
//     rating: 4.6,
//     effectiveness: 85,
//     lastUpdated: "5 days ago"
//   },
//   {
//     id: 5,
//     title: "Managing team member permissions",
//     category: "Account Management",
//     views: 3650,
//     successRate: 82,
//     rating: 4.4,
//     effectiveness: 80,
//     lastUpdated: "1 week ago"
//   },
//   {
//     id: 6,
//     title: "Troubleshooting connection errors",
//     category: "Technical Support",
//     views: 3420,
//     successRate: 70,
//     rating: 4.1,
//     effectiveness: 68,
//     lastUpdated: "4 days ago"
//   },
//   {
//     id: 7,
//     title: "Payment method update procedures",
//     category: "Billing & Payments",
//     views: 3180,
//     successRate: 89,
//     rating: 4.7,
//     effectiveness: 87,
//     lastUpdated: "6 days ago"
//   },
//   {
//     id: 8,
//     title: "Advanced feature configuration guide",
//     category: "Product Features",
//     views: 2950,
//     successRate: 75,
//     rating: 4.2,
//     effectiveness: 73,
//     lastUpdated: "1 week ago"
//   },
//   {
//     id: 9,
//     title: "Data export and backup options",
//     category: "Product Features",
//     views: 2780,
//     successRate: 78,
//     rating: 4.3,
//     effectiveness: 76,
//     lastUpdated: "3 days ago"
//   },
//   {
//     id: 10,
//     title: "Security best practices checklist",
//     category: "Technical Support",
//     views: 2620,
//     successRate: 88,
//     rating: 4.6,
//     effectiveness: 86,
//     lastUpdated: "2 days ago"
//   },
//   {
//     id: 11,
//     title: "Mobile app installation guide",
//     category: "Product Features",
//     views: 2450,
//     successRate: 80,
//     rating: 4.4,
//     effectiveness: 78,
//     lastUpdated: "5 days ago"
//   },
//   {
//     id: 12,
//     title: "Subscription plan comparison",
//     category: "Billing & Payments",
//     views: 2320,
//     successRate: 85,
//     rating: 4.5,
//     effectiveness: 83,
//     lastUpdated: "1 week ago"
//   },
//   {
//     id: 13,
//     title: "Webhook configuration tutorial",
//     category: "Technical Support",
//     views: 2180,
//     successRate: 65,
//     rating: 3.8,
//     effectiveness: 62,
//     lastUpdated: "4 days ago"
//   },
//   {
//     id: 14,
//     title: "Custom domain setup instructions",
//     category: "Technical Support",
//     views: 1950,
//     successRate: 70,
//     rating: 4.0,
//     effectiveness: 68,
//     lastUpdated: "6 days ago"
//   },
//   {
//     id: 15,
//     title: "Cancellation and refund policy",
//     category: "Billing & Payments",
//     views: 1820,
//     successRate: 92,
//     rating: 4.8,
//     effectiveness: 90,
//     lastUpdated: "2 days ago"
//   }];


//   const searchAnalyticsData = [
//   { query: "password reset", successful: 2450, failed: 120 },
//   { query: "billing issue", successful: 1890, failed: 340 },
//   { query: "API error", successful: 1650, failed: 580 },
//   { query: "account setup", successful: 1420, failed: 180 },
//   { query: "payment failed", successful: 1280, failed: 290 },
//   { query: "integration help", successful: 980, failed: 420 },
//   { query: "webhook config", successful: 750, failed: 650 },
//   { query: "data export", successful: 680, failed: 220 }];


//   const heatMapData = [];
//   const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
//   days?.forEach((day) => {
//     for (let i = 0; i < 12; i++) {
//       heatMapData?.push({
//         day,
//         timeSlot: i,
//         usage: Math.floor(Math.random() * 100),
//         segment: ['all', 'enterprise', 'smb', 'individual']?.[Math.floor(Math.random() * 4)]
//       });
//     }
//   });

//   return (
//     <>
//       <PrimaryNavigation />
//       <div className="main-content">
//         <div className="min-h-screen bg-background">
//           <NavigationBreadcrumb />
//           <main className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8">
//             <div className="mb-6 md:mb-8">
//               <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
//                 Knowledge Base Analytics
//               </h1>
//               <p className="text-sm md:text-base text-muted-foreground">
//                 Optimize AI agent effectiveness through content utilization insights and knowledge gap identification
//               </p>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
//               {topMetrics?.map((metric, index) =>
//               <MetricsCard key={index} {...metric} />
//               )}
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
//               <div className="lg:col-span-2">
//                 <ArticlePerformanceBubble data={bubbleChartData} />
//               </div>
//               <div className="space-y-4 md:space-y-6">
//                 <TrendingTopics topics={trendingTopics} />
//               </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
              


//               <div className="space-y-4 md:space-y-6">
//                 <MissingContent gaps={missingContentGaps} />
//                 <RecentUpdates updates={recentUpdates} />
//               </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
//               <SearchAnalytics data={searchAnalyticsData} />
//               <UsageHeatMap data={heatMapData} />
//             </div>

//             <ContentTable articles={articleTableData} />

//             <div className="mt-6 md:mt-8">
//               <div className="flex items-center justify-between mb-4">
//                 <div>
//                   <h2 className="text-xl md:text-2xl font-semibold text-foreground">Knowledge Base Management</h2>
//                   <p className="text-sm text-muted-foreground mt-1">Manage knowledge bases used by AI agents</p>
//                 </div>
//                 <Button
//                   variant="default"
//                   iconName="Plus"
//                   onClick={() => setIsCreateModalOpen(true)}>

//                   Create Knowledge Base
//                 </Button>
//               </div>
//               <KnowledgeBaseTable
//                 knowledgeBases={knowledgeBases}
//                 onEdit={handleEdit}
//                 onDelete={handleDelete}
//                 onHistory={handleHistory} />

//             </div>
//           </main>
//         </div>
//       </div>

//       <CreateKnowledgeBaseModal
//         isOpen={isCreateModalOpen}
//         onClose={() => setIsCreateModalOpen(false)}
//         availableAgents={availableAgents} />


//       <EditKnowledgeBasePane
//         isOpen={isEditPaneOpen}
//         onClose={handleCloseEditPane}
//         knowledgeBase={selectedKnowledgeBase}
//         availableAgents={availableAgents} />


//       <HistoryPane
//         isOpen={isHistoryPaneOpen}
//         onClose={handleCloseHistoryPane}
//         knowledgeBase={selectedKnowledgeBase}
//         historyData={selectedKnowledgeBase ? historyDataMap?.[selectedKnowledgeBase?.id] : []} />

//     </>);

// };

// export default KnowledgeBaseAnalytics;


import React, { useState, useEffect } from 'react';
import PrimaryNavigation from '../../components/ui/PrimaryNavigation';
import NavigationBreadcrumb from '../../components/ui/NavigationBreadcrumb';
import Button from '../../components/ui/Button';
import MetricsCard from './components/MetricsCard';
import ArticlePerformanceBubble from './components/ArticlePerformanceBubble';
import TrendingTopics from './components/TrendingTopics';
import MissingContent from './components/MissingContent';
import RecentUpdates from './components/RecentUpdates';
import ContentTable from './components/ContentTable';
import SearchAnalytics from './components/SearchAnalytics';
import UsageHeatMap from './components/UsageHeatMap';
import KnowledgeBaseTable from './components/KnowledgeBaseTable';
import CreateKnowledgeBaseModal from './components/CreateKnowledgeBaseModal';
import EditKnowledgeBasePane from './components/EditKnowledgeBasePane';
import HistoryPane from './components/HistoryPane';
import api from '../../api/axios';

const KnowledgeBaseAnalytics = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditPaneOpen, setIsEditPaneOpen] = useState(false);
  const [isHistoryPaneOpen, setIsHistoryPaneOpen] = useState(false);
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState(null);
  const [knowledgeBases, setKnowledgeBases] = useState([]);
  const [loading, setLoading] = useState(true);

  const [availableAgents, setAvailableAgents] = useState([]);


  const fetchKnowledgeBases = async () => {
  try {
    setLoading(true);
    const response = await api.get('/api/v1/dashboard/get-knowledge-base');

    if (response.data?.data?.knowledgeBases) {
      const transformedData = response.data.data.knowledgeBases.map((kb) => ({
        id: kb.id, // ✅ REAL DB ID
        name: kb.knowledgeBaseName,
        type: kb.knowledgeBaseType === 'LINK' ? 'Link' : 'Doc',
        link: kb.url || kb.filePath || '',
        lastUpdated: kb.createdAt,
        createdBy: kb.createdBy,
        usedByAgents: kb.agentNames || []
      }));

      // console.log(transformedData)

      setKnowledgeBases(transformedData);
    }
  } catch (err) {
    console.error('Error fetching knowledge bases:', err);
  } finally {
    setLoading(false);
  }
};

  // Fetch agents from API
  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await api.get('/api/v1/dashboard/get-agents');
        
        if (response.data?.success && response.data?.data?.agents) {
          // Transform API data to match component structure
          const transformedAgents = response.data.data.agents.map((agent) => ({
            id: agent.agentId,
            name: agent.agentName
          }));
          
          setAvailableAgents(transformedAgents);
        }
      } catch (err) {
        console.error('Error fetching agents:', err);
        // Fallback to default agents if API fails
        setAvailableAgents([
          { id: 'agent-1', name: 'Sales Agent' },
          { id: 'agent-2', name: 'Support Agent' },
          { id: 'agent-3', name: 'Technical Agent' },
          { id: 'agent-4', name: 'Billing Agent' },
          { id: 'agent-5', name: 'Customer Success Agent' },
          { id: 'agent-6', name: 'Onboarding Agent' }
        ]);
      }
    };

    fetchAgents();
  }, []);

  // Fetch knowledge bases from API
  useEffect(() => {
    // const fetchKnowledgeBases = async () => {
    //   try {
    //     setLoading(true);
    //     const response = await api.get('/api/v1/dashboard/get-knowledge-base');
        
    //     if (response.data?.data?.knowledgeBases) {
    //       // Transform API data to match component structure
    //       const transformedData = response.data?.data?.knowledgeBases.map((kb, index) => ({
    //         id: `kb-${index + 1}`,
    //         name: kb.knowledgeBaseName,
    //         type: kb.knowledgeBaseType === 'LINK' ? 'Link' : 'Doc',
    //         link: kb.url || kb.filePath || '',
    //         lastUpdated: kb.createdAt,
    //         createdBy: kb.createdBy,
    //         usedByAgents: kb.agentNames || []
    //       }));
          
    //       setKnowledgeBases(transformedData);
    //     }
    //   } catch (err) {
    //     console.error('Error fetching knowledge bases:', err);
    //   } finally {
    //     setLoading(false);
    //   }
    // };




    fetchKnowledgeBases();
  }, []);

  const historyDataMap = {
    'kb-1': [
      {
        timestamp: '2026-01-02T10:30:00',
        user: 'John Smith',
        change: 'Link Changed: Updated to new documentation URL'
      },
      {
        timestamp: '2025-12-15T14:20:00',
        user: 'Sarah Johnson',
        change: 'Agent added: Technical Agent'
      },
      {
        timestamp: '2025-12-01T09:15:00',
        user: 'John Smith',
        change: 'Name Changed: From "Product Docs" to "Product Documentation"'
      }
    ],
    'kb-2': [
      {
        timestamp: '2025-12-28T16:45:00',
        user: 'Sarah Johnson',
        change: 'New Doc Uploaded: billing-policy-v2.pdf'
      },
      {
        timestamp: '2025-12-20T11:30:00',
        user: 'Mike Chen',
        change: 'Agent removed: Sales Agent'
      }
    ],
    'kb-3': [
      {
        timestamp: '2025-12-20T13:00:00',
        user: 'Mike Chen',
        change: 'Link Changed: Updated API endpoint documentation'
      }
    ],
    'kb-4': [
      {
        timestamp: '2025-12-15T10:00:00',
        user: 'Emily Davis',
        change: 'Agent added: Sales Agent'
      },
      {
        timestamp: '2025-12-10T15:30:00',
        user: 'Emily Davis',
        change: 'New Doc Uploaded: onboarding-checklist.docx'
      }
    ],
    'kb-5': [
      {
        timestamp: '2026-01-01T08:00:00',
        user: 'David Wilson',
        change: 'Link Changed: Updated FAQ page URL'
      },
      {
        timestamp: '2025-12-25T12:00:00',
        user: 'David Wilson',
        change: 'Agent added: Technical Agent'
      }
    ]
  };

  const handleEdit = (kb) => {
    setSelectedKnowledgeBase(kb);
    setIsEditPaneOpen(true);
  };

  // const handleDelete = (kb) => {
  //   console.log('Delete knowledge base:', kb);
  // };

  const handleDelete = async (kb) => {
  // if (!window.confirm(`Delete "${kb.name}"?`)) return;

  try {
    await api.delete(
      `/api/v1/dashboard/delete-knowledge-base/${kb.id}`
    );
    fetchKnowledgeBases(); // ✅ refresh
  } catch (err) {
    console.error('Delete failed:', err);
  }
};


  const handleHistory = (kb) => {
    setSelectedKnowledgeBase(kb);
    setIsHistoryPaneOpen(true);
  };

  const handleCloseEditPane = () => {
    setIsEditPaneOpen(false);
    setSelectedKnowledgeBase(null);
  };

  const handleCloseHistoryPane = () => {
    setIsHistoryPaneOpen(false);
    setSelectedKnowledgeBase(null);
  };

  const topMetrics = [
    {
      title: "Total Articles",
      value: "1,247",
      change: "+23 this month",
      changeType: "positive",
      icon: "FileText",
      iconColor: "bg-gradient-to-br from-primary to-secondary",
      description: "Active knowledge base content"
    },
    {
      title: "Utilization Rate",
      value: "78.4%",
      change: "+5.2% vs last month",
      changeType: "positive",
      icon: "TrendingUp",
      iconColor: "bg-gradient-to-br from-success to-secondary",
      description: "Articles accessed in last 30 days"
    },
    {
      title: "Avg. Effectiveness",
      value: "82.1%",
      change: "+3.8% improvement",
      changeType: "positive",
      icon: "Target",
      iconColor: "bg-gradient-to-br from-accent to-warning",
      description: "Resolution success rate"
    },
    {
      title: "Content Freshness",
      value: "91.2%",
      change: "-2.1% needs update",
      changeType: "negative",
      icon: "RefreshCw",
      iconColor: "bg-gradient-to-br from-secondary to-primary",
      description: "Updated within 90 days"
    }
  ];

  const bubbleChartData = [
    { id: 1, title: "How to reset password", views: 2450, successRate: 92, rating: 4.8, category: "account" },
    { id: 2, title: "Billing cycle explained", views: 1890, successRate: 88, rating: 4.6, category: "billing" },
    { id: 3, title: "API integration guide", views: 1650, successRate: 75, rating: 4.2, category: "technical" },
    { id: 4, title: "Setting up two-factor auth", views: 1420, successRate: 85, rating: 4.5, category: "account" },
    { id: 5, title: "Understanding pricing tiers", views: 1280, successRate: 90, rating: 4.7, category: "billing" },
    { id: 6, title: "Troubleshooting connection issues", views: 1150, successRate: 68, rating: 3.9, category: "technical" },
    { id: 7, title: "Managing team members", views: 980, successRate: 82, rating: 4.4, category: "account" },
    { id: 8, title: "Payment method updates", views: 890, successRate: 86, rating: 4.5, category: "billing" },
    { id: 9, title: "Advanced feature configuration", views: 750, successRate: 72, rating: 4.1, category: "product" },
    { id: 10, title: "Data export procedures", views: 680, successRate: 78, rating: 4.3, category: "product" },
    { id: 11, title: "Security best practices", views: 620, successRate: 88, rating: 4.6, category: "technical" },
    { id: 12, title: "Mobile app setup", views: 580, successRate: 80, rating: 4.4, category: "product" },
    { id: 13, title: "Subscription cancellation", views: 520, successRate: 92, rating: 4.8, category: "billing" },
    { id: 14, title: "Webhook configuration", views: 450, successRate: 65, rating: 3.8, category: "technical" },
    { id: 15, title: "Custom domain setup", views: 380, successRate: 70, rating: 4.0, category: "technical" }
  ];

  const categoryData = [
    {
      id: 1,
      name: "Billing & Payments",
      icon: "CreditCard",
      articleCount: 156,
      totalViews: 45280,
      performance: 87,
      avgRating: 4.6,
      topArticles: [
        { id: 1, title: "Understanding your invoice", views: 3420, successRate: 91, rating: 4.8 },
        { id: 2, title: "Payment method updates", views: 2890, successRate: 88, rating: 4.7 },
        { id: 3, title: "Refund policy explained", views: 2650, successRate: 85, rating: 4.5 }
      ]
    },
    {
      id: 2,
      name: "Technical Support",
      icon: "Wrench",
      articleCount: 342,
      totalViews: 78920,
      performance: 72,
      avgRating: 4.2,
      topArticles: [
        { id: 1, title: "API troubleshooting guide", views: 4120, successRate: 76, rating: 4.3 },
        { id: 2, title: "Connection error solutions", views: 3890, successRate: 70, rating: 4.1 },
        { id: 3, title: "Performance optimization tips", views: 3450, successRate: 68, rating: 4.0 }
      ]
    },
    {
      id: 3,
      name: "Account Management",
      icon: "User",
      articleCount: 198,
      totalViews: 52340,
      performance: 85,
      avgRating: 4.5,
      topArticles: [
        { id: 1, title: "Password reset procedures", views: 5420, successRate: 93, rating: 4.9 },
        { id: 2, title: "Profile settings guide", views: 4280, successRate: 87, rating: 4.6 },
        { id: 3, title: "Team member management", views: 3920, successRate: 82, rating: 4.4 }
      ]
    },
    {
      id: 4,
      name: "Product Features",
      icon: "Zap",
      articleCount: 289,
      totalViews: 61450,
      performance: 79,
      avgRating: 4.3,
      topArticles: [
        { id: 1, title: "Getting started guide", views: 6120, successRate: 88, rating: 4.7 },
        { id: 2, title: "Advanced features overview", views: 4890, successRate: 75, rating: 4.2 },
        { id: 3, title: "Integration capabilities", views: 4320, successRate: 72, rating: 4.1 }
      ]
    }
  ];

  const trendingTopics = [
    {
      id: 1,
      title: "AI agent configuration best practices",
      searches: 1847,
      change: "+127% vs last week",
      trend: "up",
      relatedArticles: ["Setup Guide", "Advanced Config"]
    },
    {
      id: 2,
      title: "Multi-channel integration setup",
      searches: 1523,
      change: "+89% vs last week",
      trend: "up",
      relatedArticles: ["WhatsApp Setup", "Email Config"]
    },
    {
      id: 3,
      title: "Call recording compliance requirements",
      searches: 1289,
      change: "+64% vs last week",
      trend: "up",
      relatedArticles: ["Legal Guide", "Storage Options"]
    },
    {
      id: 4,
      title: "Performance optimization techniques",
      searches: 1156,
      change: "+52% vs last week",
      trend: "up",
      relatedArticles: ["Speed Tips", "Best Practices"]
    },
    {
      id: 5,
      title: "Custom workflow automation",
      searches: 987,
      change: "-12% vs last week",
      trend: "down",
      relatedArticles: ["Workflow Builder", "Automation Rules"]
    }
  ];

  const missingContentGaps = [
    {
      id: 1,
      topic: "Advanced webhook retry logic configuration",
      description: "Multiple escalations indicate customers need detailed guidance on configuring webhook retry mechanisms and failure handling strategies.",
      escalationCount: 47,
      failedSearches: 156,
      priority: "high"
    },
    {
      id: 2,
      topic: "GDPR compliance for call recordings",
      description: "Increasing queries about data retention policies, customer consent management, and right-to-deletion procedures for recorded conversations.",
      escalationCount: 34,
      failedSearches: 128,
      priority: "high"
    },
    {
      id: 3,
      topic: "Custom AI training with industry-specific terminology",
      description: "Enterprise customers requesting documentation on training AI agents with specialized vocabulary and domain-specific language patterns.",
      escalationCount: 28,
      failedSearches: 94,
      priority: "medium"
    },
    {
      id: 4,
      topic: "Multi-language support implementation",
      description: "Growing demand for guidance on setting up and managing AI agents that can handle conversations in multiple languages simultaneously.",
      escalationCount: 22,
      failedSearches: 76,
      priority: "medium"
    }
  ];

  const recentUpdates = [
    {
      id: 1,
      title: "Updated: API rate limiting best practices",
      date: "2 hours ago",
      type: "updated",
      impact: "positive",
      impactValue: "+18% success rate",
      viewsChange: "+245 views",
      successRate: 89
    },
    {
      id: 2,
      title: "New: WhatsApp Business API integration guide",
      date: "5 hours ago",
      type: "new",
      impact: "positive",
      impactValue: "+32 escalations resolved",
      viewsChange: "412 views",
      successRate: 85
    },
    {
      id: 3,
      title: "Updated: Billing cycle FAQ with new examples",
      date: "1 day ago",
      type: "updated",
      impact: "positive",
      impactValue: "+12% success rate",
      viewsChange: "+189 views",
      successRate: 91
    },
    {
      id: 4,
      title: "Archived: Legacy API v1 documentation",
      date: "2 days ago",
      type: "archived",
      impact: "neutral",
      impactValue: "No impact",
      viewsChange: "-156 views",
      successRate: 0
    }
  ];

  const articleTableData = [
    {
      id: 1,
      title: "How to reset your account password",
      category: "Account Management",
      views: 5420,
      successRate: 93,
      rating: 4.9,
      effectiveness: 91,
      lastUpdated: "2 days ago"
    },
    {
      id: 2,
      title: "Understanding your monthly invoice",
      category: "Billing & Payments",
      views: 4890,
      successRate: 88,
      rating: 4.7,
      effectiveness: 86,
      lastUpdated: "1 week ago"
    },
    {
      id: 3,
      title: "API integration quickstart guide",
      category: "Technical Support",
      views: 4320,
      successRate: 76,
      rating: 4.3,
      effectiveness: 74,
      lastUpdated: "3 days ago"
    },
    {
      id: 4,
      title: "Setting up two-factor authentication",
      category: "Account Management",
      views: 3980,
      successRate: 87,
      rating: 4.6,
      effectiveness: 85,
      lastUpdated: "5 days ago"
    },
    {
      id: 5,
      title: "Managing team member permissions",
      category: "Account Management",
      views: 3650,
      successRate: 82,
      rating: 4.4,
      effectiveness: 80,
      lastUpdated: "1 week ago"
    },
    {
      id: 6,
      title: "Troubleshooting connection errors",
      category: "Technical Support",
      views: 3420,
      successRate: 70,
      rating: 4.1,
      effectiveness: 68,
      lastUpdated: "4 days ago"
    },
    {
      id: 7,
      title: "Payment method update procedures",
      category: "Billing & Payments",
      views: 3180,
      successRate: 89,
      rating: 4.7,
      effectiveness: 87,
      lastUpdated: "6 days ago"
    },
    {
      id: 8,
      title: "Advanced feature configuration guide",
      category: "Product Features",
      views: 2950,
      successRate: 75,
      rating: 4.2,
      effectiveness: 73,
      lastUpdated: "1 week ago"
    },
    {
      id: 9,
      title: "Data export and backup options",
      category: "Product Features",
      views: 2780,
      successRate: 78,
      rating: 4.3,
      effectiveness: 76,
      lastUpdated: "3 days ago"
    },
    {
      id: 10,
      title: "Security best practices checklist",
      category: "Technical Support",
      views: 2620,
      successRate: 88,
      rating: 4.6,
      effectiveness: 86,
      lastUpdated: "2 days ago"
    },
    {
      id: 11,
      title: "Mobile app installation guide",
      category: "Product Features",
      views: 2450,
      successRate: 80,
      rating: 4.4,
      effectiveness: 78,
      lastUpdated: "5 days ago"
    },
    {
      id: 12,
      title: "Subscription plan comparison",
      category: "Billing & Payments",
      views: 2320,
      successRate: 85,
      rating: 4.5,
      effectiveness: 83,
      lastUpdated: "1 week ago"
    },
    {
      id: 13,
      title: "Webhook configuration tutorial",
      category: "Technical Support",
      views: 2180,
      successRate: 65,
      rating: 3.8,
      effectiveness: 62,
      lastUpdated: "4 days ago"
    },
    {
      id: 14,
      title: "Custom domain setup instructions",
      category: "Technical Support",
      views: 1950,
      successRate: 70,
      rating: 4.0,
      effectiveness: 68,
      lastUpdated: "6 days ago"
    },
    {
      id: 15,
      title: "Cancellation and refund policy",
      category: "Billing & Payments",
      views: 1820,
      successRate: 92,
      rating: 4.8,
      effectiveness: 90,
      lastUpdated: "2 days ago"
    }
  ];

  const searchAnalyticsData = [
    { query: "password reset", successful: 2450, failed: 120 },
    { query: "billing issue", successful: 1890, failed: 340 },
    { query: "API error", successful: 1650, failed: 580 },
    { query: "account setup", successful: 1420, failed: 180 },
    { query: "payment failed", successful: 1280, failed: 290 },
    { query: "integration help", successful: 980, failed: 420 },
    { query: "webhook config", successful: 750, failed: 650 },
    { query: "data export", successful: 680, failed: 220 }
  ];

  const heatMapData = [];
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  days?.forEach((day) => {
    for (let i = 0; i < 12; i++) {
      heatMapData?.push({
        day,
        timeSlot: i,
        usage: Math.floor(Math.random() * 100),
        segment: ['all', 'enterprise', 'smb', 'individual']?.[Math.floor(Math.random() * 4)]
      });
    }
  });

  return (
    <>
      <PrimaryNavigation />
      <div className="main-content">
        <div className="min-h-screen bg-background">
          <NavigationBreadcrumb />
          <main className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8">
            <div className="mb-6 md:mb-8">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
                Knowledge Base
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Optimize AI agent effectiveness through content utilization insights and knowledge gap identification
              </p>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
              {topMetrics?.map((metric, index) =>
                <MetricsCard key={index} {...metric} />
              )}
            </div> */}

            {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="lg:col-span-2">
                <ArticlePerformanceBubble data={bubbleChartData} />
              </div>
              <div className="space-y-4 md:space-y-6">
                <TrendingTopics topics={trendingTopics} />
              </div>
            </div> */}

            {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="space-y-4 md:space-y-6">
                <MissingContent gaps={missingContentGaps} />
                <RecentUpdates updates={recentUpdates} />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
              <SearchAnalytics data={searchAnalyticsData} />
              <UsageHeatMap data={heatMapData} />
            </div> */}

            <ContentTable articles={articleTableData} />

            <div className="mt-6 md:mt-8">
              <div className="flex items-center justify-between mb-4">
                {/* <div>
                  <h2 className="text-xl md:text-2xl font-semibold text-foreground">Knowledge Base Management</h2>
                  <p className="text-sm text-muted-foreground mt-1">Manage knowledge bases used by AI agents</p>
                </div> */}
                <Button
                  variant="default"
                  iconName="Plus"
                  onClick={() => setIsCreateModalOpen(true)}
                >
                  Create Knowledge Base
                </Button>
              </div>
              <KnowledgeBaseTable
                knowledgeBases={knowledgeBases}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onHistory={handleHistory}
                loading={loading}
              />
            </div>
          </main>
        </div>
      </div>

      <CreateKnowledgeBaseModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        availableAgents={availableAgents}
      />

      {/* <EditKnowledgeBasePane
        isOpen={isEditPaneOpen}
        onClose={handleCloseEditPane}
        knowledgeBase={selectedKnowledgeBase}
        availableAgents={availableAgents}
      /> */}

      <EditKnowledgeBasePane
  isOpen={isEditPaneOpen}
  onClose={handleCloseEditPane}
  knowledgeBase={selectedKnowledgeBase}
  availableAgents={availableAgents}
  onSuccess={fetchKnowledgeBases} // ✅ added
/>


      <HistoryPane
        isOpen={isHistoryPaneOpen}
        onClose={handleCloseHistoryPane}
        knowledgeBase={selectedKnowledgeBase}
        historyData={selectedKnowledgeBase ? historyDataMap?.[selectedKnowledgeBase?.id] : []}
      />
    </>
  );
};

export default KnowledgeBaseAnalytics;